import { wrapper, createApiClient, Result, ApiError } from "../base";
import ResourceTreeNodeDO = App.Data.ResourceTreeNodeDO;
import { useExplorerStore } from "@/modules/explorer/store";
import FileDTO = App.Data.FileDTO;

const basePath = `resource-tree-nodes`;
const baseClient = createApiClient();

const default_category = "requested_documents";

export default class {
	getNewResourceTreeNodes(
		resource_tree_category = default_category
	): Promise<Result<ResourceTreeNodeDO, ApiError>> {
		return wrapper(
			baseClient.get(`${basePath}/new`, {
				params: { category: resource_tree_category },
			})
		);
	}
	getResourceTreeNodes(
		resource_tree_category = default_category
	): Promise<Result<ResourceTreeNodeDO[], ApiError>> {
		return wrapper(
			baseClient.get(`${basePath}`, {
				params: { category: resource_tree_category },
			})
		);
	}

	createResourceTreeNode(
		resourceTreeNode: ResourceTreeNodeDO
	): Promise<Result<ResourceTreeNodeDO, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, resourceTreeNode));
	}
	updateResourceTreeNode(
		resourceTreeNode: ResourceTreeNodeDO
	): Promise<Result<ResourceTreeNodeDO[], ApiError>> {
		return wrapper(
			baseClient.put(`${basePath}/${resourceTreeNode.uuid}`, resourceTreeNode)
		);
	}
	removeResourceTreeNode(
		resourceTreeNode: ResourceTreeNodeDO
	): Promise<Result<ResourceTreeNodeDO[], ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${resourceTreeNode.uuid}`));
	}
	getNewFile(): Promise<Result<App.Data.FileDTO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/files/new`));
	}
}
